<template>
  <article-detail-component v-if="article">
    <div slot="anchors" class="anchors">
      <div v-for="(value, key) in anchors"><a :class="{active: key === currentSection }" :href="'#'+key">{{ value }}</a></div>
    </div>

    <div slot="keywords" class="keywords">
      <div class="title">
        Keywords:
      </div>
      <div class="">
        <div class="link" v-for="keyword in article.keywords">{{keyword}}</div>
      </div>
    </div>

    <sidebar-article-section slot="bar" :article="article"></sidebar-article-section>

    <div slot="title">
      <div class="type">{{ article.article_type.name }}</div>
      <div class="title">{{ article.title }}</div>
      <div class="ids">DOI: <span>{{article.ids.doi}}</span>Issue: <span>Volume {{article.volume}}, Issue {{article.issue}}</span>pp {{article.page_start}}-{{article.page_end}}</div>
      <issue-authors v-bind:authors="article.authors"></issue-authors>
      <div class="article-quick-links" v-if="$store.state.isEnhanced">
        <article-quick-links :article="article"></article-quick-links>
      </div>
    </div>

    <div slot="full_text">
      <section>
        <a class="jumpto hidden-md-up" @click="openNav()">Jump To</a>
        <p>
        <h1 id="Abstract">ABSTRACT</h1>
        <div class="fullText" v-html="article.abstract"></div>
        </p>
      </section>
      <div class="fullText" v-for="sectionItem in article.fullText.sections" v-if="sectionItem.title">
        <section>
          <a class="jumpto hidden-md-up" @click="openNav()">Jump To</a>
          <content-header :header-level="sectionItem.headerLevel" :title="sectionItem.title"></content-header>
          <template v-for="contentItem in sectionItem.content">
            <template v-if="contentItem.contentType === 'subsection'">
              <content-header :header-level="contentItem.headerLevel" :title="contentItem.title"></content-header>
              <template  v-for="subsectionItem in contentItem.content">
                <content-item :content-item="subsectionItem"></content-item>
              </template>
            </template>
            <content-item v-else :content-item="contentItem"></content-item>
          </template>
        </section>
      </div>
      <div class="fullText" v-for="sectionItem in article.fullText.acks" v-if="sectionItem.title">
        <section>
          <a class="jumpto hidden-md-up" @click="openNav()">Jump To</a>
          <content-header :header-level="1" :title="sectionItem.title"></content-header>
          <template v-for="contentItem in sectionItem.content">
            <content-item :content-item="contentItem"></content-item>
          </template>
        </section>
      </div>
      <div class="fullText" v-for="sectionItem in article.fullText.footnotes" v-if="sectionItem.title">
        <section>
          <a class="jumpto hidden-md-up" @click="openNav()">Jump To</a>
          <content-header :header-level="1" :title="sectionItem.title"></content-header>
          <template v-for="contentItem in sectionItem.content">
            <content-item :content-item="contentItem"></content-item>
          </template>
        </section>
      </div>
      <div class="fullText" v-if="article.fullText.references">
        <section>
          <a class="jumpto hidden-md-up" @click="openNav()">Jump To</a>
          <content-header :header-level="1" :title="'References'"></content-header>
          <p v-for="reference in article.fullText.references" :id="reference.id">
            <span>{{reference.number}}. </span>
            <span v-for="content in reference.textContent">{{content.content}}</span>
          </p>
        </section>
      </div>
    </div>
  </article-detail-component>
</template>

<script>
  import ArticleQuickLinks from '@/components/shared/ArticleQuickLinksComponent'
  import IssueAuthors from '@/components/shared/IssueAuthorsComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  import ArticleDetailComponent from '@/components/publications/article-detail/ArticleDetailComponent'
  import ContentHeader from '@/components/shared/article-items/ContentHeaderComponent'
  import ContentItem from '@/components/shared/article-items/ContentItemComponent'
  import SidebarArticleSection from '@/components/main-layout/sidebar/SidebarArticleSectionComponent'

  export default {
    name: 'article-detail',
    data () {
      return {
        currentSection: false,
        article: false,
        anchors: {}
      }
    },
    mixins: [ UtilityMixin ],
    components: {
      ArticleQuickLinks,
      IssueAuthors,
      ArticleDetailComponent,
      ContentHeader,
      ContentItem,
      SidebarArticleSection
    },
    methods: {
      fillAnchors () {
        // Fill anchors menu
        if (this.article && this.article.abstract) {
          this.anchors['Abstract'] = 'Abstract'
        }
        if (this.article && this.article.fullText && this.article.fullText.sections) {
          for (var i = 0; i < this.article.fullText.sections.length; i++) {
            if (this.article.fullText.sections[i].title) {
              this.anchors[this.article.fullText.sections[i].title.replace(/ /g, '')] = this.article.fullText.sections[i].title
            }
          }
        }
        if (this.article && this.article.fullText && this.article.fullText.acks) {
          for (i = 0; i < this.article.fullText.acks.length; i++) {
            if (this.article.fullText.acks[i].title) {
              this.anchors[this.article.fullText.acks[i].title.replace(/ /g, '')] = this.article.fullText.acks[i].title
            }
          }
        }
        if (this.article && this.article.fullText && this.article.fullText.footnotes) {
          for (i = 0; i < this.article.fullText.footnotes.length; i++) {
            if (this.article.fullText.footnotes[i].title) {
              this.anchors[this.article.fullText.footnotes[i].title.replace(/ /g, '')] = this.article.fullText.footnotes[i].title
            }
          }
        }
        if (this.article && this.article.fullText && this.article.fullText.references) {
          this.anchors['References'] = 'References'
        }
      },
      openNav () {
        this.$root.$emit('show::modal', 'navModal', this.anchors)
      }
    },
    created () {
      this.$parent.$parent.prevPage = false
      this.$parent.$parent.nextPage = {name: 'article-metrics'}
      this.$parent.$parent.prevSlide = false
      this.$parent.$parent.nextSlide = {name: 'article-detail-authors'}
      if (this.$parent.article) {
        this.article = Object.assign({}, this.$parent.article)
        this.fillAnchors()
      }
    },
    watch: {
      article: function () {
        this.fillAnchors()
      }
    }
  }
</script>


<style lang="scss" scoped>
  [id]:before {
    display: block;
    content: "";
    height: 55px;
    margin: -55px 0 0;
  }
  .jumpto {
    position: absolute;
    top: 60px;
    right: 0;
    font-style: italic;
  }
  .anchors {
    padding: 10px;
    background-color: $devider;
    a {
      text-decoration: underline;
      color: $accent-color-2;
      padding: 5px;
      display: block;
    }
    a.active {
      color: $black;
      font-weight: 700;
      text-decoration: none;
    }
  }

  .keywords {
    margin-top: 10px;
    .title {
      font-family: 'Merriweather';
      font-style: italic;
      color: $primary-color;
      font-size: 14px;
      margin-bottom: 15px;
    }
    .link {
      height: 48px;
      line-height: 48px;
      text-align: center;
      font-family: 'Merriweather';
      font-style: italic;
      font-size: 16px;
      color: $primary-color;
      background-color: #F2E8E8;
      margin-bottom: 12px;
      display: inline-block;
      width: 135px;
      margin-right: 5px;
    }
  }

  .ids {
    margin: 15px 0;
    span {
      font-family: 'Open Sans', sans-serif;
      font-size: 14px;
      line-height: 1.21;
      text-align: left;
      color: #21797e;
      margin-bottom: 36.5px;
      margin-right: 15px;
      text-decoration: underline;
    }
  }
  .type {
    font-style: italic;
    font-family: Merriweather;
    font-weight: 300;
  }
  .title {
    color: $primary-color;
    font-size: 32px;
  }
  h1 {
    color: $primary-color;
    font-weight: 300;
    font-size: 24px;
    text-transform: uppercase;
  }
  h2 {
    color: $primary-color;
    font-weight: 300;
    font-size: 18px;
    text-transform: uppercase;
  }
  .article-quick-links {
    margin-bottom: 60px;
  }
  section {
    text-align: justify;
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// ArticleDetailPage.vue?0b363ed1